import React from "react";
import { RevolvingDot } from "react-loader-spinner";
import './loader.css'
const Loader = () => {
    return (
        <div className="dot-loader">
            <RevolvingDot
                visible={true}
                height="50"
                width="50"
                color="#669d24"
                animationDuration="0.5"
                ariaLabel="revolving-dot-loading"
                wrapperStyle={{}}
                wrapperClass=""
            />
        </div>
    );
};

export default Loader;